export const bookingOverviewColumns = [
    { id: 'resourceName', labelId: 'intl-msg:marketplace.bookings.overview.toolbar.resource' },
    { id: 'variantName', labelId: 'intl-msg:marketplace.bookings.overview.table.variant' },
    { id: 'periodLength', labelId: 'intl-msg:marketplace.bookings.overview.table.period' },
    { id: 'startsAt', labelId: 'intl-msg:marketplace.bookings.overview.table.startDate' },
    { id: 'endsAt', labelId: 'intl-msg:marketplace.bookings.overview.table.endDate' },
    { id: 'remainingDays', labelId: 'intl-msg:marketplace.bookings.overview.table.daysLeft' },
    { id: 'contractState', labelId: 'intl-msg:marketplace.bookings.overview.table.status' },
    { id: 'renewsToLevelName', labelId: 'intl-msg:marketplace.bookings.overview.table.renewsTo' },
] as const;

export type BookingOverviewColumn = (typeof bookingOverviewColumns)[number]['id'];
export const defaultBookingOverviewColumns: BookingOverviewColumn[] = bookingOverviewColumns.map(({ id }) => id);
export type BookingOverviewGrouping = 'services' | 'resources';
